<template lang="pug">
	.row
		.col-md-6
			.widget
				.widget-body
					h4.widget-section-title Payout
					.row
						.col-sm-6
							.form-group
								label Payout Mode
								select.form-control(v-model="placement.payout_mode")
									option(value="fixed") Fixed
									option(value="dynamic") Dynamic
						.col-sm-6(v-if="placement.payout_mode === 'dynamic' || placement.payout_type === 'CPI'")
							.form-group
								label Payout
								.input-group-wrapper
									.input-group
										input.form-control(type="text", :placeholder="placement.payout_mode === 'fixed' ? '0.00' : '0'", v-model="placement.payout")
										.input-group-append
											span.input-group-text {{ placement.payout_mode === 'fixed' ? '$' : '%' }}
					.row
						.col-sm-6(v-if="placement.payout_mode === 'fixed'")
							.form-group
								label Payout Model
								select.form-control(v-model="placement.payout_type")
									option(:value="undefined") Auto
									option(value="CPI") CPI
									option(value="CPA", disabled) CPA
									
						.col-sm-6(v-if="placement.payout_mode === 'fixed' && placement.payout_type === undefined")
							.form-group
								label Init payout
									i.la.la-info-circle.ml-1(v-b-tooltip.hover.right, title="new placements of this publisher will have inital payout of this percent out of the offer's payout")
								.input-group
									input.form-control(type="text", placeholder="Eg. 90", v-model="defaultPlacementPayoutModel")
									div.input-group-append
										span.input-group-text %  			

					.form-group
						<!-- Only CPA or Auto (undefined) allows multiple conversions -->
						b-form-checkbox(v-model="placement.allow_multiple_conversions", :disabled="placement.payout_type !== 'CPA' && placement.payout_type !== undefined") Allow multiple conversions for the same click

					p.clearfix &nbsp;
					div(v-if="USER.permissions['placements::RISK']")
						h4.widget-section-title Risk
						.row
							.col-sm-8
								.form-group
									label &nbsp;
									.toggle-wrapper
										full-transparency-disabled-tooltip(:enabled="isFullTransparency")
											toggle-button(v-model="placement.custom_report", :disabled="isFullTransparency", :color="fullTransparencyDisabledSwitchColor", :width="40", :height="20", :font-size="14")
										span.lbl Override auto-report
											i.la.la-info-circle.ml-1(v-if="!isFullTransparency", v-b-tooltip.hover.right, title="When enabled - publisher's risk is ignored and determined by this configuration")
							.col-sm-4(v-if="placement.custom_report && !isFullTransparency")
								.form-group
									label Risk Management
									.input-group
										input.form-control(type="text", placeholder="", v-model.number="placement.risk_management")
										div.input-group-append
											span.input-group-text %

						.row
							.col-sm-12
								.form-group
									label &nbsp;
									.toggle-wrapper
										full-transparency-disabled-tooltip(:enabled="isFullTransparency")
											toggle-button(v-model="placement.report_offer_closed", :disabled="isFullTransparency", :color="fullTransparencyDisabledSwitchColor", :width="40", :height="20", :font-size="14")
										span.lbl Keep reporting even if offer is closed

							.col-sm-12
								.form-group
									label &nbsp;
									.toggle-wrapper
										full-transparency-disabled-tooltip(:enabled="isFullTransparency")
											toggle-button(v-model="placement.report_on_overcap", :disabled="isFullTransparency", :color="fullTransparencyDisabledSwitchColor", :width="40", :height="20", :font-size="14")
										span.lbl Keep reporting even if conversion cap reached
								.form-group
									label &nbsp;
									.toggle-wrapper
										full-transparency-disabled-tooltip(:enabled="isFullTransparency")
											toggle-button(v-model="placement.report_on_offer_overcap", :disabled="isFullTransparency", :color="fullTransparencyDisabledSwitchColor", :width="40", :height="20", :font-size="14")
										span.lbl Keep reporting even if offer conversion cap reached

			.widget(v-if="USER.config.s2sOffer")
				.widget-header
					h2.title Tracking
				.widget-body
					.form-group.d-flex.align-items-center(v-if="USER.config.s2sOffer")
						b-form-checkbox(v-model="placement.s2s") S2S Support (Server-To-Server)
						i.la.la-info-circle.ml-1.s2s-flow-help-icon(v-b-modal.s2s-flow-help-modal-defaults, tabindex="0")
						b-modal#s2s-flow-help-modal-defaults(size="xl", centered, hide-footer, title="", modal-class="s2s-flow-help-modal")
							img.s2s-flow-help-img(src="/assets/misc/s2s-flow-overview.jpeg", alt="S2S flow")
					.form-group
						b-form-checkbox(v-model="placement.preview_on_block") Redirect to Preview URL on Block

			os-network-targeting(v-model="osNetworkParams")

		.col-sm-6
			.widget
				//.widget-header
					h2.title More
				.widget-body
					h4.widget-section-title Filters
					.row
						.col-sm-4
							.form-group
								label Redirect Type
								select.form-control(v-model="placement.redirect_type")
									option(v-for="o in redirectTypeOptions", :value="o.v") {{ o.t }}
						.col-sm-4(v-if="placement.redirect_type === '200'")
							.form-group
								label Redirect Delay (seconds)
								input.form-control(type="number", v-model="placement.redirect_delay")
					.row
					
						//.col-sm-6(v-if="USER.config.autoOptimizePlacements")
							.form-group
								label &nbsp;
								div.toggle-wrapper
									toggle-button(v-model="placement.auto_optimize", :width="40", :height="20", :font-size="14")
									span.lbl Auto Optimize
									i.la.la-info-circle.ml-1(v-b-tooltip.hover.right, title="When enabled - placement will be automatically optimized for the best performance. Publisher's Sub2 will be ignored and auto-generated by the platform")
						.col-sm-6
							.form-group
								label &nbsp;
								div.toggle-wrapper
									toggle-button(v-model="placement.block_iframe", :width="40", :height="20", :font-size="14")
									span.lbl Block iframe
						.col-sm-6(v-if="USER.config.blockSuspiciousHeaders")
							.form-group
								label &nbsp;
								div.toggle-wrapper
									toggle-button(v-model="placement.block_suspicious_headers", :width="40", :height="20", :font-size="14")
									span.lbl Block Suspicious Headers
						.col-sm-6
							.form-group
								label &nbsp;
								div.toggle-wrapper
									toggle-button(v-model="placement.block_proxies", :width="40", :height="20", :font-size="14")
									span.lbl Block proxies


					p.clearfix &nbsp;
					h4.widget-section-title Caps
					.row
						.col-sm-4
							.form-group
								label Daily Clicks Cap
								number-input(v-model="placement.daily_click_cap")
						.col-sm-4
							.form-group
								label Daily Impression Cap
							fieldset.border-0.p-0.m-0(:disabled="isImprRateCapDerived(placement.impression_rate, USER.config.impressionCapAutoCalculation)")
								number-input(v-model="placement.daily_impression_cap")
							p.form-text(v-if="placement.daily_click_cap > 0 && placement.daily_impression_cap === 0 && !isImprRateCapDerived(placement.impression_rate, USER.config.impressionCapAutoCalculation)") Paused on click cap &nbsp;
									i.la.la-info-circle(v-b-tooltip.hover.bottom, title="There is no cap on impressions, but once the click cap is reached placement will be paused")

						.col-sm-4
							.form-group
								label Daily Conversion Cap (Actual)
								number-input(v-model="placement.daily_conversion_cap")

					.row
						.col-sm-6
							.form-group
								label Click pacing (Minute)
								number-input(v-model="placement.click_pacing")
								p.form-text.text-muted(v-if="!placement.click_pacing") No limit of clicks / minute
								p.form-text(v-if="placement.click_pacing") Max {{placement.click_pacing | numberCommas }} clicks / minute
						.col-sm-6
							.form-group
								label Click pacing (Hour)
								number-input(v-model="placement.click_pacing_hour")
								p.form-text.text-muted(v-if="!placement.click_pacing_hour") No limit of clicks / hour
								p.form-text(v-if="placement.click_pacing_hour") Max {{placement.click_pacing_hour | numberCommas }} clicks / hour
					.row
						.col-sm-6
							.form-group
								label Impression pacing (Minute)
								number-input(v-model="placement.impression_pacing")
								p.form-text.text-muted(v-if="!placement.impression_pacing") No limit of impressions / minute
								p.form-text(v-if="placement.impression_pacing") Max {{placement.impression_pacing | numberCommas }} impressions / minute
						.col-sm-6
							.form-group
								label Impression pacing (Hour)
								number-input(v-model="placement.impression_pacing_hour")
								p.form-text.text-muted(v-if="!placement.impression_pacing_hour") No limit of impressions / hour
								p.form-text(v-if="placement.impression_pacing_hour") Max {{placement.impression_pacing_hour | numberCommas }} impressions / hour

					p.clearfix &nbsp;
					h4.widget-section-title(v-if="(USER.config && USER.config.impressionRate) || USER.special_account_features") Misc
					.row(v-if="USER.config && USER.config.impressionRate")
						.col-sm-6
							impratio(
								v-model="placement.impression_rate",
								:click-cap="placement.daily_click_cap",
								:impression-cap="placement.daily_impression_cap",
								@update-impression-cap="placement.daily_impression_cap = $event"
							)


					// div(v-if="USER.special_account_features")
						.row
							.col-sm-6
								.form-group
									label Send % of pixel traffic to fallback
									.input-group(style="width: 90px;")
										input.form-control(style="padding: 7px 4px; text-align: center;", type="number", v-model.number="placement.smartlink_pixel", max="100", min="-1")
										.input-group-append
											.input-group-text %

			
					h4.widget-section-title Timeframe restriction
					timeframe-restriction(:params="timeframeParams", v-on:update-timeframe="updateTimeframe")

</template>
<script>
import Vue from 'vue';
import { isImprRateCapDerived } from '../utils/impression-rate-ctr-goal';
import FullTransparencyDisabledTooltip, { FULL_TRANSPARENCY_DISABLED_SWITCH_COLOR } from './FullTransparencyDisabledTooltip.vue';

export default {
	name: 'PlacementDefaults',
	components: { FullTransparencyDisabledTooltip },
	props: {
		placement: Object,
		default_placement_payout: Number,
		fullTransparency: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		USER() {
			return this.$store.state.user;
		},
		isFullTransparency() {
			return !!this.fullTransparency;
		},
		fullTransparencyDisabledSwitchColor() {
			return FULL_TRANSPARENCY_DISABLED_SWITCH_COLOR;
		},
		defaultPlacementPayoutModel: {
			get() {
				return this.default_placement_payout;
			},
			set(v) {
				this.$emit('update:default_placement_payout', v);
			},
		},
	},
	data() {
		return {
			overrideName: false,
			currencyOptions: Vue.ovData.general.currencyOptions,
			redirectTypeOptions: [
				{ v: '200', t: 'HTTP 200 (After page load)' },
				{ v: '302', t: 'HTTP 302 (Default)' },
			],
			osNetworkParams: {
				carrier_whitelist: (this.placement.carrier_whitelist || []).filter((id) => id !== 0),
				carrier_blacklist: this.placement.carrier_blacklist || [],
				isp_whitelist: (this.placement.isp_whitelist || []).filter((id) => id !== 0),
				isp_blacklist: this.placement.isp_blacklist || [],
				allow_no_isp: (this.placement.isp_whitelist || []).includes(0),
				allow_no_carrier: (this.placement.carrier_whitelist || []).includes(0),
				should_block_wifi: this.placement.should_block_wifi || false,
				os_targeting: this.placement.os_targeting || null,
				os_targeting_version_min: this.placement.os_targeting_version_min || null,
				os_targeting_version_max: this.placement.os_targeting_version_max || null,
				os_version_blacklist: this.placement.os_version_blacklist || [],
				advanced_targeting_whitelist: this.placement.advanced_targeting_whitelist || [],
				advanced_targeting_blacklist: this.placement.advanced_targeting_blacklist || [],
			},
			timeframeParams: {
				restrict_timeframe_schedule: this.placement.restrict_timeframe_schedule,
				restrict_timeframe_timezone: this.placement.restrict_timeframe_timezone,
				restrict_timeframe: this.placement.restrict_timeframe,
			},
		};
	},
	watch: {
		"placement.payout_type": {
			handler(v) {
				if (v !== 'CPA' && v !== undefined) {
					this.placement.allow_multiple_conversions = false;
				}
			},
			immediate: true,
		},
		osNetworkParams: {
			handler(newValue) {
				this.placement.carrier_whitelist = newValue.carrier_whitelist;
				this.placement.carrier_blacklist = newValue.carrier_blacklist;
				this.placement.isp_whitelist = newValue.isp_whitelist;
				this.placement.isp_blacklist = newValue.isp_blacklist;
				this.placement.allow_no_isp = newValue.allow_no_isp;
				this.placement.allow_no_carrier = newValue.allow_no_carrier;
				this.placement.should_block_wifi = newValue.should_block_wifi;
				this.placement.os_targeting = newValue.os_targeting;
				this.placement.os_targeting_version_min = newValue.os_targeting_version_min;
				this.placement.os_targeting_version_max = newValue.os_targeting_version_max;
				this.placement.os_version_blacklist = newValue.os_version_blacklist;
				this.placement.advanced_targeting_whitelist = newValue.advanced_targeting_whitelist;
				this.placement.advanced_targeting_blacklist = newValue.advanced_targeting_blacklist;
				this.$emit('update:placement', this.placement);
			},
			deep: true,
		},
	},
	methods: {
		isImprRateCapDerived,
		updateTimeframe(params) {
			this.placement.restrict_timeframe = params.restrict_timeframe;
			this.placement.restrict_timeframe_timezone = params.restrict_timeframe_timezone;
			this.placement.restrict_timeframe_schedule = params.restrict_timeframe_schedule;
			this.timeframeParams = {
				restrict_timeframe: params.restrict_timeframe,
				restrict_timeframe_timezone: params.restrict_timeframe_timezone,
				restrict_timeframe_schedule: params.restrict_timeframe_schedule,
			};
			this.$emit('update:placement', this.placement);
		},
	},
};
</script>
